import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const OVEStore = {
  namespaced: true,
  state: {
    oveActions: [],
    oveDetail: null,
  },
  getters,
  mutations,
  actions,
}

export default OVEStore
